import { EStatus, TFilterDictionary, TStatus, TTagType } from 'common/types'

export function getTagColor(status?: TStatus): TTagType {
  if (EStatus.ABANDONED.toUpperCase() === status) {
    return 'red'
  }
  if (EStatus.CANCELLED.toUpperCase() === status) {
    return 'red'
  }
  if (EStatus.CLOSED.toUpperCase() === status) {
    return 'green'
  }
  if (EStatus['IN PROGRESS'].toUpperCase() === status) {
    return 'yellow'
  }
  if (EStatus.OPEN.toUpperCase() === status) {
    return 'yellow'
  }
  if (EStatus.PENDING.toUpperCase() === status) {
    return 'yellow'
  }
  if (EStatus.RESOLVED.toUpperCase() === status) {
    return 'green'
  }
  return 'gray'
}

export function getTagtext(
  filterDictionary: TFilterDictionary | undefined,
  status?: TStatus,
): string {
  const canceled = filterDictionary?.CANCELED
  const completed = filterDictionary?.COMPLETED
  const underReview = filterDictionary?.UNDER_REVIEW
  const awaiting = filterDictionary?.AWAITING

  if (canceled && completed && underReview && awaiting) {
    if (status) {
      if (EStatus.ABANDONED.toUpperCase() === status) {
        return canceled
      }
      if (EStatus.CANCELLED.toUpperCase() === status) {
        return canceled
      }
      if (EStatus.CLOSED.toUpperCase() === status) {
        return completed
      }
      if (EStatus['IN PROGRESS'].toUpperCase() === status) {
        return underReview
      }
      if (EStatus.OPEN.toUpperCase() === status) {
        return underReview
      }
      if (EStatus.PENDING.toUpperCase() === status) {
        return underReview
      }
      if (EStatus.RESOLVED.toUpperCase() === status) {
        return completed
      }
      if (EStatus.AWAITING.toUpperCase() === status) {
        return awaiting
      }

      return awaiting
    }
  }

  return 'undefined'
}
